import { motion } from 'framer-motion';
import { luxuryEase, viewportOnce } from '../lib/motion';
import { ArrowUpRight, MapPin } from 'lucide-react';
import Photo from './Photo';

const statusStyles = {
  amber: 'bg-nosta-gold text-white',
  green: 'bg-emerald-800 text-white',
};

export default function ProjectCard({ project, featured = false, onClick }) {
  if (featured) {
    return (
      <motion.article
        initial={{ opacity: 0, y: 28 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={viewportOnce}
        transition={{ duration: 0.9, ease: luxuryEase }}
        onClick={onClick}
        className="group cursor-pointer grid lg:grid-cols-12 bg-white border border-nosta-line overflow-hidden shadow-lift"
      >
        <div className="relative lg:col-span-7 h-[240px] sm:h-[380px] lg:h-auto lg:min-h-[480px] overflow-hidden">
          <Photo
            src={project.coverImage}
            alt={project.coverImageAlt || project.title}
            sizes="(min-width: 1024px) 58vw, 100vw"
            className="w-full h-full transition-transform duration-[1.2s] ease-out group-hover:scale-105"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent lg:bg-gradient-to-r lg:from-transparent lg:to-black/10" />
        </div>
        <div className="lg:col-span-5 p-8 md:p-12 flex flex-col justify-center bg-nosta-espresso text-white">
          <span className={`self-start px-3 py-1 text-[11px] tracking-wideish uppercase ${statusStyles[project.statusColor]}`}>
            {project.status}
          </span>
          <h3 className="font-display text-4xl md:text-5xl mt-6 leading-tight">{project.title}</h3>
          <div className="flex items-center gap-2 text-white/60 mt-3 text-sm">
            <MapPin size={14} className="text-nosta-goldSoft" />
            {project.location}
          </div>
          <p className="mt-6 text-white/70 leading-relaxed">{project.description}</p>
          <div className="mt-8 inline-flex items-center gap-2 text-nosta-goldSoft text-sm tracking-wide group-hover:gap-3 transition-all">
            Detayları gör <ArrowUpRight size={16} />
          </div>
        </div>
      </motion.article>
    );
  }

  return (
    <motion.article
      whileHover={{ y: -6 }}
      transition={{ duration: 0.55, ease: luxuryEase }}
      onClick={onClick}
      className="group cursor-pointer bg-white border border-nosta-line overflow-hidden"
    >
      <div className="relative h-56 sm:h-72 overflow-hidden">
        <Photo
          src={project.coverImage}
          alt={project.coverImageAlt || project.title}
          sizes="(min-width: 768px) 50vw, 100vw"
          className="w-full h-full transition-transform duration-[1.2s] ease-out group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/65 via-black/10 to-transparent" />
        <span
          className={`absolute top-4 right-4 px-3 py-1 text-[11px] tracking-wideish uppercase ${statusStyles[project.statusColor]}`}
        >
          {project.status}
        </span>
        <div className="absolute bottom-0 left-0 right-0 p-6 text-white">
          <h3 className="font-display text-3xl">{project.title}</h3>
          <div className="flex items-center gap-2 text-white/75 mt-1 text-sm">
            <MapPin size={14} />
            {project.location}
          </div>
        </div>
      </div>
      <div className="p-6">
        <p className="text-nosta-mute leading-relaxed">{project.description}</p>
        <div className="mt-4 inline-flex items-center gap-2 text-nosta-gold text-sm tracking-wide group-hover:gap-3 transition-all">
          Detayları gör <ArrowUpRight size={16} />
        </div>
      </div>
    </motion.article>
  );
}
